import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ConfirmationDialogData {
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmButtonColor?: 'primary' | 'accent' | 'warn';
}

@Component({
  selector: "app-confirmation-dialog",
  templateUrl: "./confirmation-dialog.component.html",
})
export class ConfirmationDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
  ) {}

  get title(): string {
    return this.data.title || $localize`:@@common.confirmation.title:Are you sure?`;
  }

  get message(): string {
    return this.data.message || $localize`:@@common.confirmation.message:Are you sure you want to proceed?`;
  }

  get confirmButtonText(): string {
    return this.data.confirmButtonText || $localize`:@@common.action.confirm:Confirm`;
  }

  get cancelButtonText(): string {
    return this.data.cancelButtonText || $localize`:@@common.action.cancel:Cancel`;
  }

  get confirmButtonColor(): 'primary' | 'accent' | 'warn' {
    return this.data.confirmButtonColor || 'primary';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
